import axios from 'axios';
import { signInWithCustomToken } from 'firebase/auth';
import { auth } from '../firebase/config';

// API設定
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://api-pheuu73roa-an.a.run.app';

/**
 * LINE アクセストークンを使ってサーバー側で認証し、セッションCookieを取得
 * @param {string} accessToken - LINE アクセストークン
 * @returns {Promise<Object>} 認証結果（userInfo, firebaseUid）
 */
export const authenticateWithLine = async (accessToken) => {
  try {
    console.log('Authenticating with LINE access token...');

    // Step 1: サーバーにアクセストークンを送信してカスタムトークンを取得
    const authResponse = await axios.post(
      `${API_BASE_URL}/auth/line`,
      { accessToken },
      { withCredentials: true }
    );

    const { customToken, userInfo } = authResponse.data;

    console.log('Received custom token from server:', {
      userInfo: {
        userId: userInfo.userId,
        displayName: userInfo.displayName
      }
    });

    // Step 2: カスタムトークンを使ってFirebase Authにサインイン
    const userCredential = await signInWithCustomToken(auth, customToken);

    console.log('Signed in to Firebase Auth:', {
      uid: userCredential.user.uid
    });

    // Step 3: IDトークンを取得
    const idToken = await userCredential.user.getIdToken();

    // Step 4: IDトークンを使ってセッションCookieを作成
    const sessionResponse = await axios.post(
      `${API_BASE_URL}/auth/createSession`,
      { idToken },
      { withCredentials: true }
    );

    console.log('Session cookie created:', sessionResponse.data);

    return {
      success: true,
      userInfo,
      firebaseUid: userCredential.user.uid
    };

  } catch (error) {
    console.error('Authentication failed:', error);
    throw error;
  }
};

/**
 * ログアウト処理
 * サーバー側のセッションCookieを削除し、Firebase Authからもサインアウト
 */
export const logout = async () => {
  try {
    console.log('Logging out...');

    // Step 1: サーバー側のセッションCookieを削除
    await axios.post(
      `${API_BASE_URL}/auth/logout`,
      {},
      { withCredentials: true }
    );

    // Step 2: Firebase Authからサインアウト
    if (auth.currentUser) {
      await auth.signOut();
    }

    console.log('Logged out successfully');

    return { success: true };

  } catch (error) {
    console.error('Logout failed:', error);
    throw error;
  }
};

